module.exports = __webpack_public_path__ + "img/img20.a62f2666.svg";